(function (ng) {
    var mapping = {
        'InStock': 'In Stock',
        'OutOfStock': 'Out of Stock',
        'Warehouse': 'Online'
    };

    ng.module('evo.Compare.Filters').filter('availability', function () {
        return function (availability) {
            var list = (availability || '').split(',');

            for (var i = 0; i < list.length; i++) {
                var thisToken = list[i].trim();
                list[i] = mapping[thisToken] || thisToken;
            }

            return list.join(', ');
        };
    });
})(angular);